import { visionURL } from "../../../config/environment";
import JsonApiService from "../../../services/jsonapiService";
import Jsona from "jsona";
import { useDispatch } from "react-redux";
import {
  fetchUserAssignmentsListSuccess,
  fetchUserAssignmentsListBegin,
  updateDisplayedCourses
} from "../../../redux/actions/userAssignmentsListActions";
import normalize from "../../../redux/utils/normalize";

const dataFormatter = new Jsona();

const coursesApiService = async () =>
  new JsonApiService("courses", {
    baseUrl: `${visionURL}/learning_center/api/my_library`,
    credentials: "include"
  });

/**
 * Retrieves the items related to a course's pending assignment
 */
export const useCourses = () => {
  const dispatch = useDispatch();
  const fetchCourses = async ({
    externalFilters,
    params,
    page,
    include = [
      "user_assignment",
      "user_assignment.enrolled_training_object",
      "user_assignment.enrolled_training_object.ilt_info",
      "user_assignment.enrolled_training_object.ilt_info.instructor",
      "user_assignment.enrolled_training_object.ilt_info.training_location",
      "ilt_info",
      "ilt_info.instructor",
      "ilt_info.training_location"
    ]
  }) => {
    dispatch(fetchUserAssignmentsListBegin(params?.type));
    const service = await coursesApiService();
    const response = await service
      .customParams(params)
      .include(include)
      .where(externalFilters)
      .page(page)
      .all()
      .then(response => response.json());

    dispatch(
      fetchUserAssignmentsListSuccess(normalize(response), params?.type)
    );
    if (params?.type && response.data) {
      dispatch(
        updateDisplayedCourses({
          [params.type]: response.data.map(({ id }) => id)
        })
      );
    }
    return {
      // TODO: update from extractAttributes to deserialize when response is JSON API compliant
      data: dataFormatter.deserialize(response),
      totalCount: response.meta.totalCount
    };
  };

  const fetchCourse = async ({ trainingObjectId, include = [] }) => {
    const service = await coursesApiService();
    const response = await service
      .include(include)
      .find(trainingObjectId)
      .then(response => response.json());

    dispatch(fetchUserAssignmentsListSuccess(normalize(response)));

    return dataFormatter.deserialize(response);
  };

  return { fetchCourses, fetchCourse };
};
